const shouldLog = () => !!document.querySelector("body.woocommerce-checkout");

const cta = document.querySelector("button[data-bs-target='#shippingInfoModal']") || false;

const shippingOptionsInformation = {
	context: {},
	tests: [
		{
			run: () => {},
			shouldLog,
			weight: 5,
			description: "Showing shipping options information",
		},
		{
			run: () => {
				if (cta) cta.remove();

				console.log("running");
			},
			shouldLog,
			weight: 5,
			description: "Default situation",
		},
	],
	canBeEnabled: () => {
		return cta !== false;
		// return false;
	},
};

export default shippingOptionsInformation;
